export default __webpack_public_path__ + "static/media/A_human_header.e9eca189.png";